import React from 'react';

/**
 * SVG Icons for tag actions
 */
const EditIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);

const DeleteIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 6L9 17l-5-5"/>
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 6L6 18M6 6l12 12"/>
  </svg>
);

/**
 * TagItem Component - Single tag in the available tags list
 */
const TagItem = ({
  tag,
  isHighlighted,
  isEditing,
  editingName,
  editInputRef,
  onSelect,
  onMouseEnter,
  onStartEdit,
  onSaveEdit,
  onCancelEdit,
  onEditNameChange,
  onRequestDelete,
  canRename,
  canDelete,
}) => {
  return (
    <div
      className={`tags-picker__tag-item ${isHighlighted ? 'tags-picker__tag-item--highlighted' : ''} ${isEditing ? 'tags-picker__tag-item--editing' : ''}`}
      onClick={() => !isEditing && onSelect(tag.name)}
      onMouseEnter={onMouseEnter}
    >
      <span className="tags-picker__tag-dot" style={{ background: tag.color }} />
      
      {isEditing ? (
        <input
          ref={editInputRef}
          type="text"
          className="tags-picker__tag-edit-input"
          value={editingName}
          onChange={(e) => onEditNameChange(e.target.value)}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.key === 'Enter') onSaveEdit();
            if (e.key === 'Escape') onCancelEdit();
          }}
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <span className="tags-picker__tag-name">{tag.name}</span>
      )}
      
      {/* Actions - show on hover, not during edit */}
      {!isEditing && (
        <div className="tags-picker__tag-actions">
          {canRename && (
            <button
              className="tags-picker__tag-action"
              onClick={(e) => onStartEdit(e, tag)}
              title="Rename"
            >
              <EditIcon />
            </button>
          )}
          {canDelete && (
            <button
              className="tags-picker__tag-action tags-picker__tag-action--delete"
              onClick={(e) => onRequestDelete(e, tag.name)}
              title="Delete"
            >
              <DeleteIcon />
            </button>
          )}
        </div>
      )}
      
      {isEditing && (
        <div className="tags-picker__tag-actions">
          <button
            className="tags-picker__tag-action tags-picker__tag-action--save"
            onClick={(e) => { e.stopPropagation(); onSaveEdit(); }}
          >
            <CheckIcon />
          </button>
          <button
            className="tags-picker__tag-action"
            onClick={(e) => { e.stopPropagation(); onCancelEdit(); }}
          >
            <CloseIcon />
          </button>
        </div>
      )}
    </div>
  );
};

/**
 * TagsList Component
 * 
 * Displays the list of available tags to select from.
 */
const TagsList = ({
  tags,
  highlightedIndex,
  canCreateTag,
  editingTag,
  editingName,
  editInputRef,
  onSelect,
  setHighlightedIndex,
  onStartEdit,
  onSaveEdit,
  onCancelEdit,
  setEditingName,
  onRequestDelete,
  canRename,
  canDelete,
}) => {
  if (tags.length === 0) return null;

  return (
    <div className="tags-picker__tags-list">
      {tags.map((tag, index) => {
        const actualIndex = canCreateTag ? index + 1 : index;
        const isHighlighted = highlightedIndex === actualIndex;
        const isEditing = editingTag === tag.name;
        
        return (
          <TagItem
            key={tag.name}
            tag={tag}
            isHighlighted={isHighlighted}
            isEditing={isEditing}
            editingName={editingName}
            editInputRef={editInputRef}
            onSelect={onSelect}
            onMouseEnter={() => setHighlightedIndex(actualIndex)}
            onStartEdit={onStartEdit}
            onSaveEdit={onSaveEdit}
            onCancelEdit={onCancelEdit}
            onEditNameChange={setEditingName}
            onRequestDelete={onRequestDelete}
            canRename={canRename}
            canDelete={canDelete}
          />
        );
      })}
    </div>
  );
};

export default TagsList;

